import React, {useMemo} from "react";
import {css, cx} from "@panda/css";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {ApplicationModalButtonWithHiddenPrices} from "../../../application/components/ApplicationModalButtonWithHiddenPrices";
import {GTMEventApplicationSourceSection} from "../../../application/types/lead/GTMEvenApplicationSourceSection";
import {getApplicationLeadButtonText} from "../../../application/utils/lead/get_application_lead_button_text";
import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {useShouldShowPriceByOfferConfigAndUser} from "../../../hooks/use_should_show_price_by_offer_config_and_user";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";

interface IProps {
    vendorId: number;
    offerId: number;
    propertyId: number;
    propertyPrice?: number | null;
    propertyLink: string;
    applicationSource: number;
    applicationSourceSection: number;
    applicationButtonText?: string;
    moreInfoButtonText?: string;
    clickEvent?: () => void;
    hideApplicationButton?: boolean;
    className?: string;
    buttonSize?: IButtonSizePrimary;
    buttonClassName?: string;
}

export const QWActionButtons = (props: IProps) => {
    const {
        vendorId,
        offerId,
        propertyId,
        propertyPrice,
        propertyLink,
        applicationSource,
        applicationSourceSection,
        applicationButtonText,
        moreInfoButtonText,
        clickEvent,
        hideApplicationButton = false
    } = props;

    const target = useResponsiveLinkTarget();

    const handleDetailsButtonClick = () => clickEvent?.();

    const shouldShowPrice = useShouldShowPriceByOfferConfigAndUser({
        vendorId: vendorId
    });

    const buttonText = useMemo(() => {
        if (applicationButtonText) {
            return applicationButtonText;
        }

        return getApplicationLeadButtonText({
            isPriceHidden: !shouldShowPrice,
            isProperty: !!propertyId,
            propertyPrice
        });
    }, [propertyPrice, propertyId, shouldShowPrice, applicationButtonText]);

    const gtmData: IGTMEventLeadForm = {
        clickText: buttonText,
        source: GTMEventApplicationSourceSection.SIDEBAR_MAP_DETAIL,
        vendorName: vendorId.toString(),
        offerName: offerId.toString()
    };

    return (
        <div className={cx(buttonsHolder, props.className)}>
            {!hideApplicationButton && (
                <ApplicationModalButtonWithHiddenPrices
                    source={applicationSource}
                    sourceSection={applicationSourceSection}
                    vendorId={vendorId}
                    offerId={offerId}
                    propertyId={propertyId}
                    shouldShowPrice={shouldShowPrice}
                    gtmData={gtmData}
                    render={({handleClick}) => (
                        <Button
                            variant="filled_primary"
                            onClick={handleClick}
                            size={props.buttonSize || "big"}
                            className={props.buttonClassName}
                            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_DEVELOPER_BOX}
                        >
                            {buttonText}
                        </Button>
                    )}
                />
            )}

            <Button
                as="a"
                href={propertyLink}
                onClick={handleDetailsButtonClick}
                target={target}
                variant="none_secondary"
                size={props.buttonSize}
                className={props.buttonClassName}
            >
                {moreInfoButtonText ?? "Zobacz szczegóły"}
            </Button>
        </div>
    );
};

const buttonsHolder = css({
    display: "flex",
    flexDirection: "column",
    pt: 4,
    gap: 3,

    md: {
        pt: 3,
        flexDirection: "row",
        alignItems: "center"
    }
});
import React, {useMemo} from "react";
import {css, cx} from "@panda/css";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {ApplicationModalButtonWithHiddenPrices} from "../../../application/components/ApplicationModalButtonWithHiddenPrices";
import {GTMEventApplicationSourceSection} from "../../../application/types/lead/GTMEvenApplicationSourceSection";
import {getApplicationLeadButtonText} from "../../../application/utils/lead/get_application_lead_button_text";
import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {useShouldShowPriceByOfferConfigAndUser} from "../../../hooks/use_should_show_price_by_offer_config_and_user";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";

interface IProps {
    vendorId: number;
    offerId: number;
    propertyId: number;
    propertyPrice?: number | null;
    propertyLink: string;
    applicationSource: number;
    applicationSourceSection: number;
    applicationButtonText?: string;
    moreInfoButtonText?: string;
    clickEvent?: () => void;
    hideApplicationButton?: boolean;
    className?: string;
    buttonSize?: IButtonSizePrimary;
    buttonClassName?: string;
}

export const QWActionButtons = (props: IProps) => {
    const {
        vendorId,
        offerId,
        propertyId,
        propertyPrice,
        propertyLink,
        applicationSource,
        applicationSourceSection,
        applicationButtonText,
        moreInfoButtonText,
        clickEvent,
        hideApplicationButton = false
    } = props;

    const target = useResponsiveLinkTarget();

    const handleDetailsButtonClick = () => clickEvent?.();

    const shouldShowPrice = useShouldShowPriceByOfferConfigAndUser({
        vendorId: vendorId
    });

    const buttonText = useMemo(() => {
        if (applicationButtonText) {
            return applicationButtonText;
        }

        return getApplicationLeadButtonText({
            isPriceHidden: !shouldShowPrice,
            isProperty: !!propertyId,
            propertyPrice
        });
    }, [propertyPrice, propertyId, shouldShowPrice, applicationButtonText]);

    const gtmData: IGTMEventLeadForm = {
        clickText: buttonText,
        source: GTMEventApplicationSourceSection.SIDEBAR_MAP_DETAIL,
        vendorName: vendorId.toString(),
        offerName: offerId.toString()
    };

    return (
        <div className={cx(buttonsHolder, props.className)}>
            {!hideApplicationButton && (
                <ApplicationModalButtonWithHiddenPrices
                    source={applicationSource}
                    sourceSection={applicationSourceSection}
                    vendorId={vendorId}
                    offerId={offerId}
                    propertyId={propertyId}
                    shouldShowPrice={shouldShowPrice}
                    gtmData={gtmData}
                    render={({handleClick}) => (
                        <Button
                            variant="filled_primary"
                            onClick={handleClick}
                            size={props.buttonSize || "big"}
                            className={props.buttonClassName}
                            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_DEVELOPER_BOX}
                        >
                            {buttonText}
                        </Button>
                    )}
                />
            )}

            <Button
                as="a"
                href={propertyLink}
                onClick={handleDetailsButtonClick}
                target={target}
                variant="none_secondary"
                size={props.buttonSize}
                className={props.buttonClassName}
            >
                {moreInfoButtonText ?? "Zobacz szczegóły"}
            </Button>
        </div>
    );
};

const buttonsHolder = css({
    display: "flex",
    flexDirection: "column",
    pt: 4,
    gap: 3,

    md: {
        pt: 3,
        flexDirection: "row",
        alignItems: "center"
    }
});
